import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";

// Requests
export class ValueStorageSyncModel extends SyncModel {
  public values: SetValueStorageModel[];
}

export class SetValueStorageModel {
  public key: string;
  public value: any;
}

// Responses
export class ValueStorageDataModel extends DataModel {
  public get DM_Key(): number | string { return this.key; }
  public key: string;
  public value: any;
}

export class ValueStorageSyncDataModel extends SyncDataModel {
  public values: ValueStorageDataModel[];
  public get models(): DataModel[] { return this.values; }
  public DeserializeType(): void {
    if (Array.isArray(this.values)) {
      const ModelPrototype = Object.getPrototypeOf(new ValueStorageDataModel());
      for (let i = 0; i < this.values.length; ++i) {
        const value = this.values[i];
        if (Object.getPrototypeOf(value) !== ModelPrototype) {
          this.values[i] = Utils.GetExtend(new ValueStorageDataModel(), value);
        }
      }
    }
  }
}
